import { render } from "./RequestResponse.vue?vue&type=template&id=d07446dc&scoped=true&ts=true"
import script from "./RequestResponse.vue?vue&type=script&lang=ts"
export * from "./RequestResponse.vue?vue&type=script&lang=ts"

import "./RequestResponse.vue?vue&type=style&index=0&id=d07446dc&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07446dc"]])

export default __exports__